import cloneDeep from 'lodash/cloneDeep'

import { Account } from '@modules-deprecated/app/accounts/types'
import { TaxRate } from '@modules-deprecated/inbox/types'

import { BillFormLine, BillFormPartial } from './formData'
import { getBillLinesMock } from './getBillLinesMock'

interface GetBillFormFromExpenseCategoryProps {
  billLinesDefault: BillFormLine[] | undefined
  expenseCategory: Account | undefined
  lineIndex?: number
  linesTotal?: number
  taxRates?: TaxRate[]
}

export const getBillFormFromExpenseCategory = ({
  billLinesDefault,
  expenseCategory,
  lineIndex = 0,
  linesTotal = 1,
  taxRates,
}: GetBillFormFromExpenseCategoryProps): BillFormPartial => {
  const taxRate = expenseCategory?.taxRateId && taxRates?.find(({ id }) => id === expenseCategory?.taxRateId)

  const billLines = billLinesDefault ? cloneDeep(billLinesDefault) : getBillLinesMock(linesTotal)

  if (billLines[lineIndex]) {
    const defaultTaxRate = billLines[lineIndex].taxRate
    // Only set the tax rate if it's different from the current one
    if (taxRate && taxRate.id !== defaultTaxRate?.id) {
      billLines[lineIndex].taxRate = taxRate
    }

    // This whole function is only triggered when the expense category is changed
    // Tax filling based on that is only really relevant for DK, where expense categories have tax rates assigned in CoA
    // We want Booky (bookkeeping tag) to have priority always, so we only overwrite tax rate if there's no bookkeeping tag
    if (!taxRate && !billLines[lineIndex].bookkeepingTag) {
      billLines[lineIndex].taxRate = undefined
    }
  }

  return {
    billLines,
  }
}

export const getBillFormFromExpenseCategoryForm = (
  billForm: BillFormPartial,
  accounts?: Account[],
  taxRates?: TaxRate[],
): BillFormPartial => {
  if (!billForm?.billLines?.length) {
    return {}
  }

  const billFormPartial: BillFormPartial = {
    billLines: [],
  }

  if (billFormPartial.billLines) {
    for (let i = 0; i < billForm.billLines.length; i++) {
      const expenseCategoryId = billForm.billLines[i]?.expenseCategory?.id
      const expenseCategory = expenseCategoryId ? accounts?.find(({ id }) => id === expenseCategoryId) : undefined
      const taxRate = expenseCategory?.taxRateId && taxRates?.find(({ id }) => id === expenseCategory?.taxRateId)

      billFormPartial.billLines[i] = taxRate ? { taxRate } : {}
    }
  }

  return billFormPartial
}
